import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
// import { useLocation } from "react-router-dom";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import ServicesPageData from "../Data/ServicesPageData/ServicesPageData";
import ServiceHeader from "../components/ServicePageComps/ServiceHeader/ServiceHeader";
import ServiceBannerContent from "../components/ServicePageComps/ServiceBannerContent/ServiceBannerContent";
import ServicePortfolioSlider from "../components/ServicePageComps/ServicePortfolioSlider/ServicePortfolioSlider";
import ServicePackages from "../components/ServicePageComps/ServicePacakes/ServicePackages";
import KeyHighlights from "../components/ServicePageComps/KeyHighlights/KeyHighlights";
import ServicePagePortfolio from "../components/ServicePageComps/ServicePagePortfolios/ServicePagePortfolio";
import TestimonialSlider from "../components/TestimonialSlider/TestimonialSlider";
import ThemeStorePromo from "../components/ThemeSections/ThemeStorePromo";
import StaffAugRates from "../components/ServicePageComps/StaffAugRates/StaffAugRates";
import usePageMeta from "../Helpers/usePageMeta";

// Only the general, platform-agnostic website-build services -- not
// WordPress/Shopify/WooCommerce (the Theme Store's templates are on a
// different platform, Wix, so promoting it there would contradict what
// those pages are selling) and not webAppDevelopment/appDev (bespoke
// portals and mobile apps, not something a template replaces).
const THEME_STORE_ELIGIBLE_SERVICES = [
  "webDesign",
  "psdToHtml",
  "customWebDesign",
];

// Services that show the hourly rate card (the staff-augmentation lead offer).
const RATE_CARD_SERVICES = ["staffAugmentation", "uiUxDesign"];

// captionLine is written as a sentence fragment continuing the page's own
// heading (e.g. "...website design company"), so it isn't always
// capitalized -- capitalize it here since a meta description stands alone.
const capitalize = (text) =>
  text ? text.charAt(0).toUpperCase() + text.slice(1) : text;

const Services = () => {
  const { id } = useParams();
  // const location = useLocation();

  // console.log("Loc URL", location.pathname.split("/")[2]);

  const [serviceHeadingProps, setServiceHeadingProps] = useState(null);
  const [breadcrumbProps, setBreadcrumbProps] = useState(null);
  const [serviceBannerContentProps, setServiceBannerContentProps] =
    useState(null);
  const [servicePortfolioSliderProps, setServicePortfolioSliderProps] =
    useState(null);
  const [keyHighlightsProps, setKeyHighlightsProps] = useState(null);
  const [servicePackagesProps, setServicePackagesProps] = useState(null);
  const [servicePagePortfolioProps, setServicePagePortfolioProps] =
    useState(null);
  // const [HighlightServicesProps, setHighlightServicesProps] = useState(null);
  // const [ServicesListProps, setServicesListPropss] = useState(null);

  // const [InfoWithVideoProps, setInfoWithVideoProps] = useState(null);

  // const [pageNameForModal, setPageNameForModal] = useState("");
  // const [menuNameForModal, setMenuNameForModal] = useState("");

  const item = ServicesPageData[id];

  useEffect(() => {
    if (id) {
      if (item) {
        setBreadcrumbProps({
          pageName: item?.pageName,
          menuName: item?.menuName,
        });
        setServiceHeadingProps({
          pageName: item?.pageName,
          menuName: item?.menuName,
          titleLine: item?.titleLine,
          captionLine: item?.captionLine,
          captionLine2: item?.captionLine2,
          description: item?.description,
          // img: item?.bannerImg,
          // btnName: ConstantHelper.navBtn2,
          // btnLink: item?.demoBtnLink,
        });
        setServiceBannerContentProps({
          tagLine: item?.tagLine,
          bannerImg: item?.bannerImg,
          bannerTitle: item?.bannerTitle,
          bannerDesc: item?.bannerDesc,
          QuickAcationBtn: item?.QuickAcationBtn,
          pageModIntro: item?.pageModIntro,
        });
        setServicePortfolioSliderProps({
          portfolioCaption: item?.portfolioSlider?.portfolioCaption,
          portfolioTitle: item?.portfolioSlider?.portfolioTitle,
          portfolio: item?.portfolioSlider?.portfolioImages,
        });
        setKeyHighlightsProps({
          question: item?.keyHighlights?.question,
          description: item?.keyHighlights?.description,
          points: item?.keyHighlights?.points,
        });
        setServicePackagesProps({
          spTitle: item?.servicePackages?.spTitle,
          spCaption: item?.servicePackages?.spCaption,
          spData: item?.servicePackages?.spData,
          spShortDescription: item?.servicePackages?.spShortDescription,
          spDescription: item?.servicePackages?.spDescription,
        });
        setServicePagePortfolioProps({
          servicePortfolioTitle: item?.servicePortfolio?.servicePortfolioTitle,
          servicePortfolioCaption:
            item?.servicePortfolio?.servicePortfolioCaption,
          servicePortfolioData: item?.servicePortfolio?.servicePortfolioData,
        });
      }
    }
  }, [id]);

  usePageMeta({
    title: item?.pageName ? `${item.pageName} | TZ Creation` : undefined,
    description: capitalize(item?.captionLine || item?.bannerTitle),
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  return (
    <div style={{ color: "#777777" }}>
      <Header />
      <Breadcrumb
        parentpageName="Home"
        currentPageName="Services"
        breadcrumbProps={breadcrumbProps}
      />
      {serviceHeadingProps && (
        <ServiceHeader serviceHeadingProps={serviceHeadingProps} />
      )}
      {serviceBannerContentProps && (
        <ServiceBannerContent
          serviceBannerContentProps={serviceBannerContentProps}
        />
      )}
      {servicePortfolioSliderProps && (
        <ServicePortfolioSlider
          servicePortfolioSliderProps={servicePortfolioSliderProps}
        />
      )}
      {servicePackagesProps?.spData && servicePackagesProps.spData.length > 0 && (
        <ServicePackages servicePackagesProps={servicePackagesProps} />
      )}

      {RATE_CARD_SERVICES.includes(id) && <StaffAugRates />}

      {THEME_STORE_ELIGIBLE_SERVICES.includes(id) && <ThemeStorePromo />}

      {servicePagePortfolioProps && (
        <ServicePagePortfolio
          servicePagePortfolioProps={servicePagePortfolioProps}
          pageName={item?.pageName}
        />
      )}

      <KeyHighlights keyHighlightsProps={keyHighlightsProps} />
      <TestimonialSlider />
      <Footer />
    </div>
  );
};

export default Services;
